function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import style from "./YoutubeSearchResults.module.scss";
import { useSignal, useComputed } from "@preact/signals-react";
import { LoadMoreButton } from "../components/LoadMoreButton/LoadMoreButton";
import { YoutubeVideo } from "../YoutubeVideo/YoutubeVideo";
import { youtubeVideoData } from "../YoutubeVideo/mockData";
import { DISPLAY_COUNT } from "../Constant";
import { VBDataYoutubeVideoModel, VBDataYoutubeVideoSource } from "imagica-corekit/dist/base/api/viewBuilderTyped/VBGraphData/VBDataYoutubeVideoModel";
import { Img } from "../ImgV2/Img";
export function YoutubeSearchResults(props) {
  var videoList = useSignal(props.video_list.slice(0, DISPLAY_COUNT));
  var showVideoDetail = useSignal(false);
  var videoDetail = useSignal({
    isFromList: true,
    source: new VBDataYoutubeVideoSource(),
    video_image: "",
    video_title: "",
    url: ""
  });
  var showSeeMoreBtn = useComputed(function () {
    return videoList.value.length < props.video_list.length;
  });
  function seeMore() {
    videoList.value = props.video_list.slice(0, videoList.value.length + DISPLAY_COUNT);
  }
  function clickVideoItem() {
    showVideoDetail.value = true;
    videoDetail.value = _objectSpread({
      isFromList: true
    }, youtubeVideoData);
  }
  function back() {
    showVideoDetail.value = false;
    videoDetail.value = new VBDataYoutubeVideoModel();
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style.youtubeSearchResultsBox
  }, /*#__PURE__*/React.createElement("h1", null, "Related videos"), /*#__PURE__*/React.createElement("div", {
    className: style.list
  }, videoList.value.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: style.item,
      key: index,
      onClick: function onClick() {
        return clickVideoItem();
      }
    }, /*#__PURE__*/React.createElement(Img, {
      className: "youtubeSearchResultsImg",
      imgKey: item.video_image
    }), /*#__PURE__*/React.createElement("div", {
      className: style.info
    }, /*#__PURE__*/React.createElement("p", {
      className: style.name
    }, item.video_title), /*#__PURE__*/React.createElement("p", {
      className: style.duration
    }, item.video_length)));
  })), showSeeMoreBtn.value && /*#__PURE__*/React.createElement(LoadMoreButton, {
    btnText: "See more",
    loadMore: seeMore
  }), showVideoDetail.value && /*#__PURE__*/React.createElement("div", {
    className: style.youtubeVideoWrapper
  }, /*#__PURE__*/React.createElement(YoutubeVideo, _extends({}, videoDetail.value, {
    back: back
  }))));
}